import { gql } from '@apollo/client';
const ADD_PROJECTION_POINT = gql `
  mutation AddProjectionPoint(
    $componentId: ID
    $modelSpecificationProjectionId: ID!
    $x: Float!
    $y: Float!
    $noteX: Float!
    $noteY: Float!
    $type: String!
    $isVisible: Boolean!
  ) {
    addProjectionPoint(
      componentId: $componentId
      modelSpecificationProjectionId: $modelSpecificationProjectionId
      x: $x
      y: $y
      noteX: $noteX
      noteY: $noteY
      type: $type
      isVisible: $isVisible
    ) {
      projectionPoint {
        id
        x
        y
        noteX
        noteY
      }
    }
  }
`;
export default ADD_PROJECTION_POINT;
